export class Product {
    productid: number = null;
    productservice: string = null;
    productdesc: string = null;
    productnumber: string = null;
    producttype: string = null;
    productsetupcost: number = null;
    productpurchasecost: number = null;
    productrentalcost: number = null;
    productgroup: number = null;
}

export class ProductPicture {
    picturedata: string;
    pictureid: number;
    picturemediatype: string;
    productid: number;
}
